import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from '../styles/vipInfo.module.scss'
import { useAssetImage } from '@/platforms/utils'
import { useTranslation } from 'react-i18next'
import { useUserInfo } from '@/api/request'
import { useVipCfgList } from '../hooks/useVip'
import LoadingUI from '@/compoments/loadingUI'


const VipInfo = ({userInfo, gradeData}) => {
  const { t } = useTranslation('vip')
  const { memberGradeConfigList: ConfigList, memberInfoChangeList: changeList } = gradeData || {}

  const vipInfo = useAssetImage('vip-info',{theme: true})
  const vipDj = useAssetImage('vip-vip-dj',{theme: true})
  const vipLevel = useAssetImage('vip-level',{theme: true})
  const progress1 = useMemo(() => {
    if (!changeList?.upNeedTotalRecharge) return 0;
    const raw = (changeList?.upTotalRecharge / changeList?.upNeedTotalRecharge) * 100
    return Math.min(Math.floor(raw), 100);
  }, [changeList])

  const progress2 = useMemo(() => {
    if (!ConfigList?.[changeList?.vipGrade].relegateFlows) return 0;
    const raw = (changeList?.upTotalRecord / ConfigList?.[changeList?.vipGrade]?.relegateFlows) * 100
    return Math.min(Math.floor(raw), 100);
  }, [changeList,ConfigList])

  return (
    <div className={styles.Vip_info}>
      <div className={styles.Vip_info_top}>
        <div className={styles.left}>
          <div className={styles.avatar}>
            <img src={vipInfo} alt="" />
          </div>
          <div>
            <div className={styles.name}>
              <span>{userInfo?.name}</span>
              <div className={styles.vip_Grade}>
                <img src={vipDj} alt="" />
                <span>VIP{userInfo?.grade}</span>
              </div>
            </div>
            <div className={styles.join}>
              <div>{t('vipInfo.joinedFamily')}：<span>{userInfo?.lastDays}{t('vipInfo.day')}</span></div>
              {changeList && (<div>{t('vipInfo.needDeposit')}：<span>{changeList?.upNeedTotalRecharge - changeList?.upTotalRecharge}</span></div>)}
              {changeList && (<div>{t('vipInfo.needTurnover')}：<span>{changeList?.upNeedTotalRecord - changeList?.upTotalRecord}</span></div>)}
            </div>
          </div>
        </div>

        <div className={styles.right}>
          <div>
            <div className={styles.vip_Grade}>
              <img src={vipDj}  alt="" />
              <span>VIP{userInfo?.grade}</span>
            </div>
            <div className={styles.levelBar}>
              <div className={styles.barWrapper1}>
                <img src={vipLevel} alt="" style={{ width: `${progress1}%` }} />
              </div>
            </div>
            <div className={styles.vip_Grade}>
              <img src={vipDj}  alt="" />
              <span>VIP{userInfo?.grade + 1}</span>
            </div>
          </div>
          
          <div>
            <div className={styles.retain_t}>{t('vipInfo.levelWager')}</div>
            <div className={styles.levelBar}>
              <div className={styles.barWrapper2}>
                <img src={vipLevel}  alt="" style={{ width: `${progress2}%` }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      <div className={styles.Vip_info_bottom}>
        <div>
          <span>{t('vipInfo.currentDeposit')}：</span> <span>{changeList?.upTotalRecharge.toFixed(2)}</span> <span>{`(${changeList?.upTotalRecharge.toFixed(2)}/${changeList?.upNeedTotalRecharge.toFixed(2)})`}</span>
        </div>
        <div>
          <span>{t('vipInfo.currentWager')}：</span><span>{changeList?.upTotalRecord.toFixed(2)}</span> <span>{`(${changeList?.upTotalRecord.toFixed(2)}/${changeList?.upNeedTotalRecord.toFixed(2)})`}</span>
        </div>
      </div>
    </div>  
  )
}

export default VipInfo
